import React from 'react';

const colors = {
    primary: {
        background: '#062042',
        border: '#062042',
        color: '#fff'
    },
    success: {
        background: '#44942c',
        border: '#44942c',
        color: '#fff'
    },
    secondary: {
        background: '#2e160e',
        border: '#2e160e',
        color: '#fff'
    },
    danger: {
        background: '#dc3545',
        border: '#dc3545',
        color: '#fff'
    },
    warning: {
        background: '#d97706',
        border: '#d97706',
        color: '#fff'
    },
    info: {
        background: '#0ea5e9',
        border: '#0ea5e9',
        color: '#fff'
    },
    light: {
        background: '#f8f9fa',
        border: '#444',
        color: '#444'
    },
    dark: {
        background: '#343a40',
        border: '#343a40',
        color: '#fff'
    }
};

export default props => {

    const style = colors[props.type] || colors.primary;

    return (
        <button
            type={props.submit ? 'submit' : 'button'}
            onClick={props.event}
            disabled={props.disabled}
            className='btn btn-block'
            style={{
                background: style.background,
                border: `1px solid ${style.border}`,
                color: style.color,
                fontWeight: 600,
                fontSize: 15,
                borderRadius: 10,
                minHeight: 44,
                transition: 'all .18s ease',
                boxShadow: props.disabled
                    ? 'none'
                    : '0 3px 10px rgba(0,0,0,.12)',
                opacity: props.disabled ? .6 : 1
            }}
            onMouseEnter={e => {
                if (!props.disabled) {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 18px rgba(0,0,0,.18)';
                    e.currentTarget.style.filter = 'brightness(1.05)';
                }
            }}
            onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = props.disabled
                    ? 'none'
                    : '0 3px 10px rgba(0,0,0,.12)';
                e.currentTarget.style.filter = 'brightness(1)';
            }}
        >
            {props.icon &&
                <i
                    className={props.icon}
                    style={{
                        marginRight: props.text ? 8 : 0
                    }}
                />
            }

            {props.text}
        </button>
    );
};